export default "__VITE_ASSET__e1f356ba__"